(function () {
  'use strict';
  var TX_BRANDFILM_BUILD = '20260914-r1';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /* TX 14/09/2026: no src until within 300px of the viewport; pauses off-screen so the loop is not decoding */
  function initAuto(video) {
    /* TX 24/09/2026 (Jono): a viewer's pause sticks, so scrolling back does not restart the loop */
    var userPaused = false;
    var pauseBtn = video.parentNode.querySelector('[data-film-pause]');
    if (pauseBtn && !(REDUCED && REDUCED.matches)) {
      pauseBtn.hidden = false;
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', String(userPaused)); pauseBtn.setAttribute('aria-label', userPaused ? 'Play video' : 'Pause video'); // TX 28/09/2026: label follows the state
        if (userPaused) video.pause();
        else { load(); play(); }
      });
    }
    function load() {
      if (video.getAttribute('src')) return;
      var narrow = window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
      video.src = narrow ? video.getAttribute('data-src-sd') : video.getAttribute('data-src-hd');
      if (REDUCED && REDUCED.matches) video.controls = true;
    }
    function play() {
      if (userPaused || (REDUCED && REDUCED.matches)) return;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { load(); play(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { load(); play(); }
        else if (video.getAttribute('src')) video.pause();
      });
    }, { rootMargin: '300px 0px' }).observe(video);
  }

  function init(stage) {
    var btn = stage.querySelector('[data-film-play]');
    var filmSrc = stage.getAttribute('data-film-src');
    var vimeoId = stage.getAttribute('data-film-vimeo');
    if (!btn || (!filmSrc && !vimeoId)) return;
    btn.addEventListener('click', function () {
      var idle = stage.querySelector('[data-film-idle]');
      var el;
      if (filmSrc) {
        el = document.createElement('video');
        el.src = filmSrc;
        el.controls = true;
        el.autoplay = true;
        el.playsInline = true;
        el.className = 'tx-brandfilm__film';
      } else {
        // Vimeo loads only on this tap; dnt=1 keeps its tracking off
        el = document.createElement('iframe');
        el.src = 'https://player.vimeo.com/video/' + encodeURIComponent(vimeoId) +
                 '?autoplay=1&dnt=1&title=0&byline=0&portrait=0';
        el.allow = 'autoplay; fullscreen; picture-in-picture';
        el.allowFullscreen = true;
        el.title = 'TernX brand film';
        el.className = 'tx-brandfilm__film';
      }
      if (idle) idle.remove();
      btn.remove();
      var kicker = stage.querySelector('[data-film-kicker]');
      if (kicker) kicker.remove();
      stage.appendChild(el);
    });
  }
  function boot() {
    document.querySelectorAll('[data-tx-brandfilm]').forEach(init);
    document.querySelectorAll('[data-film-auto]').forEach(initAuto);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
